import React from "react";
import { ReportDateRangePicker } from "./ReportDateRangePicker";

type DropdownValues = {
  segment?: string;
  reportType?: string;
  fundType?: string;
  startDate: number | undefined;
  endDate: number | undefined;
  transactionType?: number;
};

type DatePickerProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setTimestamps: React.Dispatch<React.SetStateAction<DropdownValues>>;
  timestamps: DropdownValues;
};

const DateRangePickerFree: React.FC<DatePickerProps> = ({
  setTimestamps,
  timestamps,
}) => {
  return (
    <ReportDateRangePicker
      startDate={timestamps.startDate}
      endDate={timestamps.endDate}
      onChange={(range) => {
        setTimestamps((prev) => ({
          ...prev,
          startDate: range.startDate,
          endDate: range.endDate,
        }));
      }}
      variant="default"
    />
  );
};

export default DateRangePickerFree;
